module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.item,
      "rules": _vm.validation,
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "title"
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.$set(_vm.item, "title", $$v)
      },
      expression: "item.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [(_vm.item._id) ? _c('span', [_vm._v("Save")]) : _c('span', [_vm._v("Create")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b7a35a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/CreateRoomDialog.vue
// module id = 418
// module chunks = 4